import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import * as i2 from 'step-status-update-payload-service';
import * as i3 from 'reference-library';
import * as i4 from '@angular/common';
import * as i5 from '@angular/material/icon';
import { PrimengLibraryModule } from 'primeng-library';

class AssigningTaskLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
}
AssigningTaskLibraryService.ɵfac = function AssigningTaskLibraryService_Factory(t) { return new (t || AssigningTaskLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
AssigningTaskLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: AssigningTaskLibraryService, factory: AssigningTaskLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AssigningTaskLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = function (a0) { return { hideView: a0 }; };
function AssigningTaskLibraryComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "h6", 8);
    i0.ɵɵlistener("click", function AssigningTaskLibraryComponent_div_0_div_2_Template_h6_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return ctx_r5.updateStepAssignedDetails("INPROGRESS"); });
    i0.ɵɵelementStart(2, "mat-icon", 9);
    i0.ɵɵtext(3, " play_circle_outline");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 10);
    i0.ɵɵtext(5, "Do you wish to start now?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx_r2.isViewMode || ctx_r2.beneQuestIsCaseRequest === "true"));
} }
function AssigningTaskLibraryComponent_div_0_div_3_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 13);
} }
const _c1 = function (a0, a1, a2) { return { "pending": a0, "overDue": a1, "completed": a2 }; };
function AssigningTaskLibraryComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6", 11);
    i0.ɵɵtemplate(2, AssigningTaskLibraryComponent_div_0_div_3_i_2_Template, 1, 0, "i", 12);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵelementStart(4, "b");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c1, (ctx_r3.stepDetails == null ? null : ctx_r3.stepDetails.completionStatus) === "PENDING", (ctx_r3.stepDetails == null ? null : ctx_r3.stepDetails.completionStatus) === "OVERDUE", (ctx_r3.stepDetails == null ? null : ctx_r3.stepDetails.completionStatus) === "COMPLETED"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.estimateTime);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.stepDetails == null ? null : ctx_r3.stepDetails.estimatedTime);
} }
function AssigningTaskLibraryComponent_div_0_div_4_h6_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵelementStart(1, "b", 15);
    i0.ɵɵtext(2, "Assign To");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" : ", ctx_r8.stepDetails == null ? null : ctx_r8.stepDetails.assignToEmployeeName, "");
} }
function AssigningTaskLibraryComponent_div_0_div_4_h6_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵelementStart(1, "b", 16);
    i0.ɵɵtext(2, "Assign To");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" : ", ctx_r9.assignBeneficiary, "");
} }
function AssigningTaskLibraryComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, AssigningTaskLibraryComponent_div_0_div_4_h6_1_Template, 4, 1, "h6", 5);
    i0.ɵɵtemplate(2, AssigningTaskLibraryComponent_div_0_div_4_h6_2_Template, 4, 1, "h6", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.stepDetails.isPetitionerAction === 1 || ctx_r4.stepDetails.isAttorneyAction === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.stepDetails.isBeneficiaryAction === 1);
} }
function AssigningTaskLibraryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, AssigningTaskLibraryComponent_div_0_div_2_Template, 6, 3, "div", 4);
    i0.ɵɵtemplate(3, AssigningTaskLibraryComponent_div_0_div_3_Template, 6, 7, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AssigningTaskLibraryComponent_div_0_div_4_Template, 3, 2, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r0.stepDetails == null ? null : ctx_r0.stepDetails.stepStatusDetails == null ? null : ctx_r0.stepDetails.stepStatusDetails.stepStatusCode) === "NEW");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r0.stepDetails == null ? null : ctx_r0.stepDetails.stepStatusDetails == null ? null : ctx_r0.stepDetails.stepStatusDetails.stepStatusCode) === "INPROGRESS" || ctx_r0.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || ctx_r0.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.assignTo);
} }
function AssigningTaskLibraryComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "h6", 19);
    i0.ɵɵlistener("click", function AssigningTaskLibraryComponent_div_1_div_2_Template_h6_click_1_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.updateStepAssignedDetails("INPROGRESS"); });
    i0.ɵɵelementStart(2, "mat-icon", 9);
    i0.ɵɵtext(3, "play_arrow");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 20);
    i0.ɵɵtext(5, "To begin the step, press the button.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx_r10.isViewMode || ctx_r10.beneQuestIsCaseRequest === "true"));
} }
function AssigningTaskLibraryComponent_div_1_div_3_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 13);
} }
function AssigningTaskLibraryComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6", 21);
    i0.ɵɵtemplate(2, AssigningTaskLibraryComponent_div_1_div_3_i_2_Template, 1, 0, "i", 12);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵelementStart(4, "b");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c1, (ctx_r11.stepDetails == null ? null : ctx_r11.stepDetails.completionStatus) === "PENDING", (ctx_r11.stepDetails == null ? null : ctx_r11.stepDetails.completionStatus) === "OVERDUE", (ctx_r11.stepDetails == null ? null : ctx_r11.stepDetails.completionStatus) === "COMPLETED"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.estimateTime);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r11.stepDetails == null ? null : ctx_r11.stepDetails.estimatedTime);
} }
function AssigningTaskLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵtemplate(2, AssigningTaskLibraryComponent_div_1_div_2_Template, 6, 3, "div", 4);
    i0.ɵɵtemplate(3, AssigningTaskLibraryComponent_div_1_div_3_Template, 6, 7, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r1.stepDetails == null ? null : ctx_r1.stepDetails.stepStatusDetails == null ? null : ctx_r1.stepDetails.stepStatusDetails.stepStatusCode) === "NEW");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r1.stepDetails == null ? null : ctx_r1.stepDetails.stepStatusDetails == null ? null : ctx_r1.stepDetails.stepStatusDetails.stepStatusCode) === "INPROGRESS" || ctx_r1.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || ctx_r1.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT");
} }
// import { updateStepStatus } from '../../store/actions/step-status-update.actions';
class AssigningTaskLibraryComponent {
    constructor(store, stepStatusUpdatePayloadCostruction, referenceLibraryService) {
        this.store = store;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.referenceLibraryService = referenceLibraryService;
        this.updateStatus = new EventEmitter();
    }
    ngOnInit() {
        var _a, _b;
        if (sessionStorage.getItem('isSimplify') && sessionStorage.getItem('isSimplify') == 'CWF') {
            this.isSimplify = true;
        }
        else {
            this.isSimplify = false;
        }
        // console.log('AssigningTaskLibraryComponent ::', this.isViewMode);
        // console.log('AssigningTaskLibraryComponent  @Input() isCaseRequest: boolean; ::', this.isCaseRequest);
        // @Input() isCaseRequest: boolean;
        this.beneQuestIsCaseRequest = 'beneQuestIsCaseRequest' in sessionStorage ? sessionStorage.getItem('beneQuestIsCaseRequest') : 'false';
        this.estimateTime = this.stepDetails.estimatedTime ? true : false;
        this.assignTo = this.stepDetails.assigneeType ? true : false;
        this.assignBeneficiary = ((_a = this.stepDetails) === null || _a === void 0 ? void 0 : _a.assignToBeneficiaryName) ? (_b = this.stepDetails) === null || _b === void 0 ? void 0 : _b.assignToBeneficiaryName : this.stepDetails.assignToEmployeeName;
    }
    updateStepAssignedDetails(status) {
        this.updateStatus.emit(status);
    }
    ngAfterViewInit() {
        this.translet();
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
}
AssigningTaskLibraryComponent.ɵfac = function AssigningTaskLibraryComponent_Factory(t) { return new (t || AssigningTaskLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i2.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i3.ReferenceLibraryService)); };
AssigningTaskLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AssigningTaskLibraryComponent, selectors: [["lib-assigning-task-library"]], inputs: { stepDetails: "stepDetails", type: "type", visaType: "visaType", isViewMode: "isViewMode", isCaseRequest: "isCaseRequest" }, outputs: { updateStatus: "updateStatus" }, decls: 2, vars: 2, consts: [["class", "row pt-2 d-flex align-items-center", 4, "ngIf"], ["class", "row pt-0 d-flex align-items-center", 4, "ngIf"], [1, "row", "pt-2", "d-flex", "align-items-center"], [1, "col-md-9", "startTime"], [3, "ngClass", 4, "ngIf"], [4, "ngIf"], ["class", "col-md-3 assignTo pull", 4, "ngIf"], [3, "ngClass"], [1, "d-flex", "align-items-center", "flex-wrap", 3, "click"], [1, "icon"], [1, "common-bene-class-for-translation", 2, "padding-top", "10px"], [1, "d-flex", "align-items-center", "flex-wrap", 3, "ngClass"], ["class", "pi pi-clock icons", 4, "ngIf"], [1, "pi", "pi-clock", "icons"], [1, "col-md-3", "assignTo", "pull"], [2, "color", "#b1b1b1"], [2, "color", "#b1b1b1 common-bene-class-for-translation"], [1, "row", "pt-0", "d-flex", "align-items-center"], [1, "col-md-12", "startNewTime"], [1, "d-flex", "align-items-center", "flex-wrap", "mb-0", 3, "click"], [1, "common-bene-class-for-translation"], [1, "d-flex", "align-items-center", "flex-wrap", "mb-0", 3, "ngClass"]], template: function AssigningTaskLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AssigningTaskLibraryComponent_div_0_Template, 5, 3, "div", 0);
        i0.ɵɵtemplate(1, AssigningTaskLibraryComponent_div_1_Template, 4, 2, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isSimplify);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplify);
    } }, directives: [i4.NgIf, i4.NgClass, i5.MatIcon], styles: [".startTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font-weight:500}.startTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:35px;padding-right:10px;margin-right:20px;cursor:pointer}.startTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%]{font-size:27px;font-weight:600;margin-right:12px;margin-left:5px}.startTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]   .span[_ngcontent-%COMP%]{padding-top:10px}.assignTo[_ngcontent-%COMP%]{text-align:right}.assignTo[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{margin-bottom:0}.overDue[_ngcontent-%COMP%]{color:#980112}.completed[_ngcontent-%COMP%]{color:#4ec97a}.pending[_ngcontent-%COMP%]{color:#50a1da}.disabledView[_ngcontent-%COMP%]{pointer-events:none}.hideView[_ngcontent-%COMP%]{visibility:hidden}.showView[_ngcontent-%COMP%]{visibility:visible}.startNewTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#565659;font-size:15px;font-weight:600;padding-bottom:5px}.startNewTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:15px!important;padding-right:10px;padding-top:6px;margin-right:5px;cursor:pointer;padding-left:4px;background-color:#f44336;color:#fff;border-radius:3px}.startNewTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%]{font-size:15px!important;font-weight:600;margin-right:5px;margin-left:0!important}.startNewTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#002e83;font-size:14px;font-weight:600;cursor:pointer}.assignNewTo[_ngcontent-%COMP%]{text-align:right}.assignNewTo[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{margin-bottom:0;font-size:14px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AssigningTaskLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-assigning-task-library',
                templateUrl: `./assigning-task-library.component.html`,
                styleUrls: [`./assigning-task-library.component.scss`],
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.StepStatusUpdatePayloadService }, { type: i3.ReferenceLibraryService }]; }, { stepDetails: [{
            type: Input
        }], type: [{
            type: Input
        }], visaType: [{
            type: Input
        }], updateStatus: [{
            type: Output
        }], isViewMode: [{
            type: Input
        }], isCaseRequest: [{
            type: Input
        }] }); })();

class AssigningTaskLibraryModule {
}
AssigningTaskLibraryModule.ɵfac = function AssigningTaskLibraryModule_Factory(t) { return new (t || AssigningTaskLibraryModule)(); };
AssigningTaskLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: AssigningTaskLibraryModule });
AssigningTaskLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AssigningTaskLibraryModule, { declarations: [AssigningTaskLibraryComponent], imports: [PrimengLibraryModule], exports: [AssigningTaskLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AssigningTaskLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [AssigningTaskLibraryComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [AssigningTaskLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of assigning-task-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AssigningTaskLibraryComponent, AssigningTaskLibraryModule, AssigningTaskLibraryService };
//# sourceMappingURL=assigning-task-library.js.map
